<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список областей</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end"  v-if="isAdmin()">
        <a class="btn btn-success" href="/regions/0">
          Добавить
        </a>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(id)="data">
        <div class="sortable-container none"
             @click="onSortChanged('id')"
             :class="{'ascending': page.sort.id === 'ASC', 'descending': page.sort.id === 'DESC'}">
          ID
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование
        </div>
      </template>
      <template #head(mealAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('mealAmount')"
             :class="{'ascending': page.sort.mealAmount === 'ASC', 'descending': page.sort.mealAmount === 'DESC'}">
          Сумма питания
        </div>
      </template>
      <template #head(actions)="data" v-if="isAdmin()">
      </template>


      <template #cell(id)="data">
        {{ data.item.id }}
      </template>
      <template #cell(nameRu)="data">
        <a :href="`/regions/${data.item.id}`">
          {{ data.item.nameRu }}
        </a>
      </template>
      <template #cell(mealAmount)="data">
        {{ data.item.mealAmount }}
      </template>
      <template #cell(actions)="data"  v-if="isAdmin()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import regionService from "@/services/regionService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      page: {
        filter: {
          search: null
        },
        sort: {
          universityId: null,
          bin: null,
          nameRu: null,
          region: null,
          mealCostPerDay: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'nameRu', label: 'Наименование', sortable: true},
        {key: 'mealAmount', label: 'Сумма питания', sortable: true},
        {key: 'actions', label: '', sortable: false}
      ],
      items: []
    };
  },
  methods: {
    isAdmin() {
      return delegationService.isAdmin();
    },
    async reloadList() {
      this.isLoading = true;
      const response = await regionService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await regionService.deleteById(item.id);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    }
  },
  mounted() {
    this.reloadList();
  }
};
</script>

<style scoped>
.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
